export default __webpack_public_path__ + "static/media/IMG_5007-min.3958732d.JPG";